import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AppContext } from "../utilities/context";
import { FormattedMessage, useIntl } from "react-intl";
import Layout from "./Layout";
import MixcloudPlayer from "./MixcloudPlayer";
// import BandsInTownEvents from './BandsInTownEvents';
import Styles from "../../public/assets/css/main.css";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

const Show = () => {
  const context = useContext(AppContext);
  const intl = useIntl();
  const { showId } = useParams();

  useEffect(() => {
    console.log("Show ID:", showId);
    if (context) {
      // context.updateBreadcrumbsState([]);
    }
  }, []); // The empty dependency array means this effect will only run once (equivalent to componentDidMount)

  return (
    <Layout>
      <MixcloudPlayer sourceUrl={`https://www.mixcloud.com/merkurio/${showId}/`} />
      {/* <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={9}>
            <BandsInTownEvents />
          </Grid>
        </Grid>
      </Container> */}
    </Layout>
  );
};

export default Show;
